

const Api = [

    {
        id:1,
        img: "/Images/slider-badag.jpg",
    },


    {
        id:1,
        img: "/Images/slider-badging.jpg",
    },

    {
        id:1,
        img: "/Images/slider-scales.jpg",
    },

    {
        id:1,
        img: "/Images/slider-scale.jpg",
    },

    {
        id:1,
        img: "/Images/slider-scale.jpg",
    },

    {
        id:1,
        img: "/Images/slider-scale.jpg",
    },

    
]

export default Api;